const $doc = $(document);

$doc.on('change', '.js-product-option', function(event) {
	const selectedOptions = getSelectedOptionsString(event);

	updateVariantsSelect(selectedOptions)
});

/**
 * Get a string from the selected options in the pdp form
 * @return {string} selected options string
 */
function getSelectedOptionsString (event) {
	const selectedOptions = [];
	const $optionFields = $('.js-product-option');

	$optionFields.each((index, item) => {
		const selectedValue = item.value;

		selectedOptions.push(selectedValue)
	});

	const optionsString =	selectedOptions.join('-');

	return optionsString
}

/**
 * Updates the variant selct with the current selected options
 *
 * @param  {String} selectedOptions a string with selected options
 */
function updateVariantsSelect(selectedOptions) {
	const $variantsSelect = $('.js-variants-select');
	const $option = $variantsSelect.find(`option[data-title-handle="${selectedOptions}"]`);
	const $btn = $variantsSelect.closest('form').find('.js-ajax-add')

	if ($option.length) {
		const value = $option.val();

		$variantsSelect.val(value);

		$variantsSelect.change();
	}
	else {
		$btn
			.prop('disabled', true)
			.html(Shopify.theme.locale.products.product.sold_out)
	}
}
